export default class AppConstants {
  static PLATFORM_ORIGIN_CODE = 250;
  // EXTERNAL LINKS
  static CMA_URL = 'https://www.cma.com.br/';
  static SAFRAS_URL = 'https://safras.com.br/';
  static EXTERNAL_LINK_NEW_CLIENT = 'http://www2.safras.com.br/plataforma/';
  static URL_YOUTUBE_EMBED = 'https://www.youtube.com/embed/';
  static URL_SOUNDCLOUD_EMBED = 'https://w.soundcloud.com/player/?url=https://soundcloud.com/';
  static URL_SPOTIFY_EMBED = 'https://open.spotify.com/embed/episode/';

  static URL_DOCUMENT_WHATSIT_BR = 'upload/pdf-whatsisit/presentation-agriculture-precision-br.pdf';
  static URL_DOCUMENT_WHATSIT_EN = 'upload/pdf-whatsisit/presentation-agriculture-precision-en.pdf';
  static URL_DOCUMENT_WHATSIT_ES = 'upload/pdf-whatsisit/presentation-agriculture-precision-es.pdf';

  // PARAMS KEY
  // static PARAMS_TOKEN = 'access_token';
  static PARAMS_TOKEN = 'Bearer';

  // COPY COPYRIGHT
  static COPYRIGHT_TEXT_CLIPBOARD = 'Copyright 2022 Safras Consultoria - Todos os direitos reservados';

  // ********* USER ROLE PROFILE *******************
  static USER_ROLE_ADM = 'admin';
  static USER_ROLE_EDITOR = 'editor';
  static USER_ROLE_PUBLISHER = 'publisher';

  // ********* EVENTS NAME *******************
  static EVENT_LOGIN = 'loginEvent';

  // ********* TIMEOUT VALUES *******************
  static API_REST_TIMEOUT = 15000;

  static HIGHLIGHTS_TITLE_LIMIT_LENGTH = 120;

  // ********* DEFAULT PAGINATOR DATA *******************
  static TICKER_DEFAULT_LIMIT = 10;
  static HIGHLIGHTS_DEFAULT_CAROUSEL_LIMIT = 9;
  static HIGHLIGHTS_DEFAULT_CAROUSEL_SLIDE_PER_VIEW = 3;
  static PAGINATOR_DEFAULT_PAGE_SIZE = 10;
  static PAGINATOR_DEFAULT_LIMIT = 24;
  static PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50];

  // ********* LOCAL STORAGE KEYS *******************
  static LOCAL_STORAGE_HAS_LOGGED_IN = 'hasLoggedIn';
  static LOCAL_STORAGE_CURRENT_USER = 'currentUser';
  static LOCAL_STORAGE_THEME = 'theme';
  static LOCAL_STORAGE_DISPLAY_TICKER = 'displayTicker';
  static LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken';
  static LOCAL_STORAGE_LOCALE = 'locale';
  static LOCAL_STORAGE_MAIN_MENU_SIDEBAR_REDUCE = 'mainMenuSidebarReduce';
  static LOCAL_STORAGE_INFORMATIVE_SIDEBAR_REDUCE = 'informativeSidebarReduce';
  static LOCAL_STORAGE_REPORT_VIEW_STYLE = 'reportViewStyle';
  static LOCAL_STORAGE_METADATA = 'metadata';
  static LOCAL_STORAGE_FAVORITE_CONTENT = 'favoriteContent';
  static LOCAL_STORAGE_SESSION_BROWSER = 'sessionBrowser';
  static LOCAL_STORAGE_EVENT_CLOSE_SESSION = 'eventCloseOtherSessions';
  static LOCAL_STORAGE_EVENT_QUOTES_PAGE_DETACH = 'quotesPageDetach';
  static LOCAL_STORAGE_USER_SKIP_TOUR = 'skipTour';
  static LOCAL_STORAGE_USER_AFTER_LOGIN_SHOW_BIOMETRY = 'afterLoginShowMessageBiometry';
  static LOCAL_STORAGE_CURRENT_FILTER = 'currentFilter';
  static LOCAL_STORAGE_ZOOM = 'zoom';
  static LOCAL_STORAGE_CONTENT_PRIVATE = 'content-private';
  static LOCAL_STORAGE_FORMAT_ALIGN_DETAIL = 'formatAlignDetail';
  static LOCAL_STORAGE_EVENT_ON_LOGIN = 'eventOnLogin';
  static LOCAL_STORAGE_EVENT_ON_LOGIN = 'eventOnLogin';
  static LOCAL_STORAGE_COOKIES_ACCEPTED = 'cookiesAccepted';
  static LOCAL_STORAGE_COOKIES_REJECTED = 'cookiesRejected';
  static LOCAL_STORAGE_SCHEDULE_DATA = 'scheduleData';
  static LOCAL_STORAGE_HIGHLIGHT_COLLAPSED = 'highlightCollapsed';
  static LOCAL_STORAGE_ONESIGNAL_ID = 'oneSignalID';

  static LOCAL_STORAGE_BIOMETRY = 'biometry';
  static LOCAL_STORAGE_BIOMETRY_SECRETS = 'biometrySecrets';
  static LOCAL_STORAGE_BIOMETRY_SECRETS_STATUS = 'biometrySecretsStatus';
  static LOCAL_STORAGE_HAS_BIOMETRY = 'hasBiometry';
  static LOCAL_STORAGE_BIOMETRY_TYPE = 'biometryType';
  static LOCAL_STORAGE_IS_BIOMETRY_AVAILABLE = 'isBiometryAvailable';

  // ********* NAVIGATION URL *******************
  static NAVIGATION_PAGE_HOME = '/home';
  static NAVIGATION_PAGE_LOGIN = '/pages/login';
  static NAVIGATION_PAGE_REGISTER = '/pages/register';
  static NAVIGATION_PAGE_PLANS = '/pages/plans';
  static NAVIGATION_PAGE_FORGOT_PASSWORD = '/pages/forgot-password';
  static NAVIGATION_PAGE_RESET_PASSWORD = '/pages/reset-password';
  static NAVIGATION_PAGE_NEW_CLIENT = '/pages/new-client';
  static NAVIGATION_PAGE_LOST_ACCESS = '/pages/lost-access';
  static NAVIGATION_PAGE_ERROR_404 = '/pages/error-404';
  static NAVIGATION_PAGE_ERROR_500 = '/pages/error-500';
  static NAVIGATION_PAGE_CALLBACK = '/pages/callback';
  static NAVIGATION_PAGE_COMINGSOON = '/pages/comingsoon';
  static NAVIGATION_PAGE_BROWSER_NOT_SUPPORT = '/pages/browser-not-support';
  static NAVIGATION_PAGE_DOWNLOAD_PUBLIC_FILE = '/pages/download-file';
  static NAVIGATION_PAGE_MAINTENANCE = '/pages/maintenance';
  static NAVIGATION_PAGE_VERSION = '/version';
  static NAVIGATION_PAGE_LANDING_PAGE = '/landing-page';
  static NAVIGATION_PAGE_LANDING_PAGE_DETAILS = '/details';

  static NAVIGATION_PAGE_S4LOGIN = '/pages/s4login';
  static NAVIGATION_PAGE_TMNQUOTES = '/tmnquotes';
  static NAVIGATION_PAGE_MY_ACCOUNT = '/my-account';
  static NAVIGATION_PAGE_CHANGE_PASSWORD = '/change-password';
  static NAVIGATION_PAGE_INFORMATIVE = '/informative';
  static NAVIGATION_PAGE_INFO_COMMODITY_CONTENT = '/info/content';

  static NAVIGATION_PAGE_ACCOUNT = '/account';
  static NAVIGATION_PAGE_ACCOUNT_SIGNATURE = '/account/signature';
  static NAVIGATION_PAGE_ACCOUNT_NOTIFICATION = '/account/notification';
  static NAVIGATION_PAGE_ACCOUNT_CHANGE_PASSWORD = '/account/change-password';
  static NAVIGATION_PAGE_ACCOUNT_PRIVACY_POLICY = '/account/privacy-policy';
  static NAVIGATION_PAGE_ACCOUNT_PLANS = '/account/packages';

  static NAVIGATION_PAGE_ASK_TO_ANALYST = '/ask-to-analyst';

  static NAVIGATION_PAGE_ADM_SUBJECT = '/admin/subjects';
  static NAVIGATION_PAGE_ADM_SUBJECT_REGISTER = '/admin/subjects/register';

  static NAVIGATION_PAGE_ADM_USER = '/admin/users';
  static NAVIGATION_PAGE_ADM_USER_REGISTER = '/admin/users/register';

  static NAVIGATION_PAGE_ADM_TAG = '/admin/tags';
  static NAVIGATION_PAGE_ADM_TAG_REGISTER = '/admin/tags/register';


  // ********* API URI *******************
  static URL_APPLOGGER = 'logger/applogger';
  static URL_LOGIN = 'auth/new-signin';
  static URL_LOGOUT = 'auth/system/logout';
  static URL_REGISTER = 'auth/register';
  static URL_VALIDATE_CONFIRM_EMAIL_TOKEN = 'auth/validate/confirm-email-token';
  static URL_SEND_CONFIRM_EMAIL_TOKEN = 'auth/send-confirm-email-token';
  static URL_RESEND_TWO_FACTOR_AUTH_EMAIL = 'auth/resend/two-factor-auth-token';
  static URL_VALIDATE_TWO_FACTOR_AUTH_EMAIL = 'auth/validate-two-factor-auth-token';
  static URL_S4LOGIN = 'signin/s4';
  static URL_REFRESH_TOKEN = 'auth/getAccessTokenFromRefreshToken';

  static URL_CLIENT_CURRENT_SIGNATURE = 'signatures/client/current';
  static URL_CLIENT_SIGNATURES = 'signatures/client';
  static URL_FORGOT_PASSWORD = 'forgot-password/client';
  static URL_CHANGE_PASSWORD = 'change-password/client';
  static URL_RESET_PASSWORD = 'reset-password/client';
  static URL_UPDATE_PHONE = 'update-phone/client';
  static URL_SEND_PASSWORD = '';
  static URL_CONTENT_NOTIFICATION = 'content/notification';
  static URL_LIST_REPORT_ALL = 'elastic/listall';
  // static URL_LIST_REPORT_ALL = 'reportData/list/all/report';
  static URL_COMMODITY_CONFIG_FILTER = 'menu/content';
  static URL_COMMODITY_REPORT_TYPE_FILTER = 'reportData/commodity/reporttype';
  static URL_CONTENT_FILTERS = 'content/filter';
  static URL_LIST_REPORT_HIGHLIGHTS_ALL = 'reportData/list/all/report/highlight';
  static URL_NEW_CLIENT = 'authenticate/new-client';
  static URL_LOST_ACCESS = 'lost-access/client';
  static URL_VERSION = 'version';
  static URL_NEWS_DETAIL = 'news/detail';
  static URL_RELATED_NEWS = 'elastic/related-news';
  static URL_NEWS_TICKER = 'elastic/news-ticker';
  static URL_SEND_READ_NEWS = 'send-read-news';
  static URL_LANDING_PAGE = 'landing-page';
  static URL_DELETE_ACCOUNT = 'client/delete-account';
  static URL_LIST_NEWS_DETAIL = 'news/list-detail';
  static URL_USER_UPDATE_TIME_SPENT = 'client/update/time-spent';
  static URL_LIST_QUOTES_CONTENT_ALL = 'list-menu/content/quotes';

  static URL_PRIVACY_POLICY_CONTENT = 'privacy-policy-content';

  static URL_COUNTRIES = 'countries';

  static URL_GET_MAIN_MENU = 'main/menu';

  static URL_CONNECT_GET_CONSULTING = 'reportData/consulting';

  static URL_MY_ACCOUNT = 'my-account';
  static URL_USER_NOTIFICATION = 'user-notification';
  static URL_USER_CHECK_INFO = 'check/info';
  static URL_USER_GET_QUESTIONS_AVAILABLE = 'client/questions/available';
  static URL_USER_SEND_DEVICE_ID = 'public-device/register'
  static URL_CLIENT_SEND_DEVICE_ID = 'client-device/register'
  static URL_CLIENT_LOGOUT_DEVICE_ID = 'client-device/remove'
  static URL_CLIENT_CHECK_REQUEST_DEMO = 'client/signature/check-request-demo'
  static URL_CLIENT_REQUEST_DEMO = 'client/signature/request-demo'

  static URL_ASK_ANALYST = 'client/send-ask-analyst';
  static URL_ATTENDANCE = 'attendance/client';
  static URL_ATTENDANCE_PUBLIC = 'attendance/public';

  static URL_DOWNLOAD_PUBLIC_FILE = 'public/file/download';
  static URL_NEWS_READ_DOCUMENT = 'read-document';
  static URL_NEWS_DOWNLOAD_DOCUMENT_WATERMARK = 'download-document-watermark';

  static URL_PLAYLIST_LATEST_MEDIA = 'elastic/latest/media';

  static URL_CONTENT_PRIVATE = 'content-private';

  static URL_USER_COUNT_SENT_NEWS = 'user/count-sent-news';

  // ********* URL API CACHE *******************
  static URL_API_CACHE_GETALL = 'news/cache';
  static URL_API_CACHE_GETALL_HIGHLIGHTS = 'news/cache/highlights';
  static URL_API_CACHE_CONTENT = 'content';
  static URL_API_CACHE_SUBJECT = 'subjects';
  static URL_API_CACHE_VERSION = 'version';
  static URL_API_CACHE_CONTENT_PRIVATE_PUBLIC_DETAIL = 'content-private/public-detail';
  static URL_API_CACHE_CONTENT_PRIVATE_PRIVACY_POLICY = 'content-private/privacy-policy';
  static URL_API_CACHE_CONTENT_PRIVATE_QUOTES_PUBLIC = 'content-private/quotes-public';
  static URL_API_CACHE_PLANS = 'plans';

  // ********* URL DRODPOWN *******************
  static URL_DROPDOWN_AGENCY_FIND_ALL = 'dropdown/agency';
  static URL_DROPDOWN_PERMISSION_FIND_ALL = 'dropdown/permission';
  static URL_DROPDOWN_USER_PROFILE_FIND_ALL = 'dropdown/user/profile';
  static URL_DROPDOWN_LOCALE_FIND_ALL = 'dropdown/locale';
  static URL_DROPDOWN_TOPIC_FIND_ALL = 'dropdown/topic';
  static URL_DROPDOWN_HEADER_FIND_ALL = 'dropdown/header';
  static URL_DROPDOWN_SUBJECTS_FIND_ALL = 'dropdown/subjects/filter';
  static URL_DROPDOWN_TAGS_FIND_ALL = 'dropdown/tags/filter';
  static URL_DROPDOWN_KEY_REFERENCE_FIND_ALL = 'dropdown/keyreference';
  static URL_DROPDOWN_CATEGORY_FIND_ALL = 'dropdown/category/filter';
  static URL_DROPDOWN_USERS = 'filter/user-all';
  static URL_ACRONYM_GET_ONE_KEY = 'acronym/find/key';

  // ********* URL ACCEPTOR *******************
  static URL_ACCEPTOR_NEW_TOKEN = 'acceptor/newtoken';
  static URL_ACCEPTOR_REFRESH_TOKEN = 'acceptor/refresh-token';
  static URL_ACCEPTOR_CHECK_TOKEN = 'acceptor/check-token';
  static URL_ACCEPTOR_LOGOUT = 'acceptor/logout';

  // ********* URL LAYOUT *******************
  static URL_LAYOUT = 'layout';
  static URL_LAYOUT_LOAD_WDMA = 'layoutwdma/loadconfig';
  static URL_LAYOUT_SAVE_WDMA = 'layoutwdma/saveconfig';
  static URL_LAYOUT_WDMA_HIST = 'layoutwdma-hist';

  // ********* URL PDFS *******************
  static URL_PDF_WHAT_IS_IT = 'report/pdf/whatsit';

  // ********* PDF *******************
  static PDF_PWD = 'smDfzswBm3ET8YUS';

  // ********* S4 *******************
  static ERROR_S4_TOKEN = 'ERROR_S4_OTHER_LOGIN';

  // ********* BUS EVENT NAME *******************
  static BUS_EVENT_CLEAR_FILTER = 'clearFilter';
  static BUS_EVENT_CHANGE_SCALE_PDF = 'changeScalePdf';
  static BUS_EVENT_OPENA_ATTENDANCE = 'openAttendance';
  static BUS_EVENT_OPEN_USER_MENU_MOBILE = 'openUserMenuMobile';
  static BUS_EVENT_CHANGE_LOCALE = 'changeLocale';
  static BUS_EVENT_CLOSE_POPUP = 'closePopup';
  static BUS_EVENT_TOGGLE_REDUCE_MAIN_MENU = 'toggleReduceMainMenu';
  static BUS_EVENT_HEADER_MOBILE_OPEN_MAIN_MENU = 'openMainMenu';
  static BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_FILTER = 'openInformativeFilter';
  static BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_CONTENT_FILTER = 'openInformativeContentFilter';
  static BUS_EVENT_HEADER_MOBILE_SELECT_INFORMATIVE_CONTENT_FILTER = 'selectInformativeContentFilter';
  static BUS_EVENT_HEADER_MOBILE_TITLE = 'headerTitleMobile';
  static BUS_EVENT_HEADER_MOBILE_BACK = 'headerMobileOnBack';
  static BUS_EVENT_UPDATE_NUM_FILTER_MOBILE = 'updateNumberOfFilterMobile';
  static BUS_EVENT_LOAD_INFORMATIVE_FILTER = 'loadInformativeFilters';
  static BUS_EVENT_SEARCH_INFORMATIVE_MOBILE = 'searchInformativeMobile';
  static BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA = 'openDraggableMultimedia';
  static BUS_EVENT_OPEN_PLAYLIST = 'openPlaylist';
  static BUS_EVENT_CLOSE_PLAYLIST = 'closePlaylist';
  static BUS_EVENT_RUN_MEDIA_PLAYLIST = 'runMediaPlaylist';
  static BUS_EVENT_PLAY_NEXT_PLAYLIST = 'playNextItemPlaylist';
  static BUS_EVENT_OPEN_REPORT_DETAIL = 'openReportDetail';
  static BUS_EVENT_OPEN_TOUR = 'openPlatformTour';
  static BUS_EVENT_OPEN_NEWS_DETAIL = 'openNewsDetail';
  static BUS_EVENT_OPEN_AUTHOR_DETAIL = 'openAuthorDetail';
  static BUS_EVENT_OPEN_REGISTER = 'openRegister';
  static BUS_EVENT_OPEN_LOGIN = 'openLogin';
  static BUS_EVENT_OPEN_PLANS = 'openPlans';
  static BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP = 'openExclusiveContentPopup';
  static BUS_EVENT_NAVIGATE_SUBJECT = 'navigateSubject';
  static BUS_EVENT_OPEN_PLANS_MOBILE = 'openPlansMobile';
  static BUS_EVENT_OPEN_USER_SIGNATURES_MOBILE = 'openUserSignaturesMobile';
  static BUS_EVENT_REFRESH = 'refreshReports';
  static BUS_EVENT_DISPLAY_TICKER = 'displayTicker';
  static BUS_EVENT_UPDATE_HIGHLIGHTS = 'updateHighlights';
  static BUS_EVENT_CHECK_ACCEPTOR_TOKEN = 'checkAcceptorToken';
  static BUS_EVENT_RESTORE_LAYOUT_QUOTES = 'restoreLayoutQuotes';
  static BUS_EVENT_CLEAR_LOCAL_DATA_QUOTES = 'clearLocalDataQuotes';
  static BUS_EVENT_UPDATE_HIST_LAYOUT_QUOTES = 'updateHistLayoutQuotes';

  // Device Type
  static DEVICE_TYPE_MOBILE = 0;
  static DEVICE_TYPE_DESKTOP = 1;

  static PLATFORM_ANDROID = 0;
  static PLATFORM_IOS = 1;
  static PLATFORM_OTHER = 2;

  // ENUMS
  static NEWS_STATUS = {
    SENDNOW: 1,
    SAVED: 2,
    SCHEDULED: 3,
    SENT: 4,
    ERROR: 5
  };

  static REPORT_VIEW_STYLE = {
    LISTVIEW: 1,
    LISTVIEW_DETAILED: 2,
    CARDVIEW: 3,
    MOSAIC: 4,
    CALENDAR: 5,
  }

  // ********* NEWS TYPE IMPORTANCE *******************
  static NEWS_IMPORTANCE = {
    DEFAULT: 0,
    IMPORTANT: 1
  }

  static INFORMATIVE_FILTER_ALL_OPTION = {
    id: null,
    nome: "Todos",
    namePtBr: "Todos",
    nameEnEu: "All",
    nameEsEs: "Todos",
    nameEsAr: "Todos",
    namePtPt: "Todos",
    habilitado: true,
    icone: "CheckSquareIcon",
    slug: "all"
  }

  static TYPE_VIEW = {
    LIST: 'list',
    CARD: 'card',
  }

  static PLATFORM_CLIENT = {
    CMA: 'CMA',
    SAFRAS: 'SAFRAS'
  }

  static DATA_LAYOUT = {
    NEWS: 1,
    FLASHES: 2,
    PODCAST: 3,
    TVCAST: 4,
    REPORT: 5,
  }

  static FILTER_DATE_OPTION = {
    One_Day: 1,
    One_Week: 2,
    One_Month: 3,
    Three_Month: 4,
    Others: 5
  }

  static ZOOM = {
    ULTRACOMPACT: '80%',
    COMPACT: '90%',
    DEFAULT: '100%',
    BIG: '110%',
    ULTRABIG: '120%',
  }

  static DETAIL_FORMAT_ALIGN = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
  }

  static THEME = {
    DARK: 'dark',
    LIGHT: 'light'
  }

  static USER_PROFILE = {
    SUBSCRIBER: 1,
    DEMO: 2,
    FREE: 3
  }

  static DISCLOSURE_TYPE_ENUM = {
    ANNOUNCEMENT: 1,
    INVITE: 2,
    ECONOMIC_CALENDAR: 3
  };

  static LOCATION = {
    DETAIL_PUBLIC: 'detail-public',
    DETAIL_PRIVATE_SUBSCRIBER: 'detail-private-subscriber',
    DETAIL_PRIVATE_DEMO: 'detail-private-demo',
    DETAIL_PRIVATE_FREE: 'detail-private-free'
  }

  static DISCLOSURE_TYPE_ENUM = {
    ANNOUNCEMENT: 1,
    INVITE: 2,
    ECONOMIC_CALENDAR: 3
  };

  static DISCLOSURE_TYPE_LIST = [
    { id: this.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT, name: 'Anúncio', color: 'calendar-color-announcement' },
    { id: this.DISCLOSURE_TYPE_ENUM.INVITE, name: 'Convite', color: 'calendar-color-invite' },
  ];

  static BIOMETRY_TYPE = {
    TOUCH_ID: 'TouchID',
    FACE_ID: 'FaceID',
    OPTIC_ID: 'OpticID',
    FINGERPRINT: 'Fingerprint',
    FACE: 'Face',
    IRIS: 'Iris',

  }

  static APP_SYSTEM = {
    REACT: 'react',
    APP: 'app',
    CORDOVA: 'cordova',

  }

}
